import * as React from 'react';
import * as styles from '../styles.scss';
import * as dateFns from 'date-fns';
import { CheckBox, DatePicker, Fallback } from 'components/common';
import { IState } from 'redux/global-reducers';
import * as classNames from 'classnames';
import { WithNamespaces, withNamespaces } from 'react-i18next';
import { connect } from 'react-redux';
import { handleError } from 'utils/common';
import { withErrorBoundary } from 'react-error-boundary';
import { IOrderForm, IOrderFormConfig, OrderFormFieldKey } from '../config';
import { FormikErrors } from 'formik';
import { formatDateToString, formatStringToDate } from 'utils/datetime';
import { DATE_FORMAT_DISPLAY } from 'constants/main';

interface IExpiryDateSectionProps
  extends React.ClassAttributes<ExpiryDateComponent>,
    WithNamespaces {
  readonly config: IOrderFormConfig;
  readonly values: IOrderForm;
  readonly isDerivatives: boolean;
  readonly isOddlot: boolean;
  readonly isNotOrderTypeLO: boolean;

  readonly onChangeExpiryDate: (expiryDate: Date) => void;
  readonly onChangeExpiryCheckBox: (value: boolean) => void;
  readonly isWeekday: (date: Date) => boolean;

  readonly ErrorMessage: React.FC<{
    readonly message?: string;
  }>;
  readonly errors: FormikErrors<IOrderForm>;
}

class ExpiryDateComponent extends React.Component<IExpiryDateSectionProps> {
  render() {
    const {
      config,
      ErrorMessage,
      errors,
      values,
      isDerivatives,
      isOddlot,
      isNotOrderTypeLO,
      onChangeExpiryDate,
      isWeekday,
      onChangeExpiryCheckBox,
    } = this.props;
    return (
      <>
        {config[OrderFormFieldKey.EXPIRY_DATE] != null && (
          <div
            className={classNames(styles.ExpiryDateSection, styles.FormField, {
              [styles.HiddenField]: isDerivatives,
            })}
            style={config[OrderFormFieldKey.EXPIRY_DATE]?.style}
          >
            <div className={styles.MainField}>
              <div className={styles.FieldInput}>
                <CheckBox
                  disabled={isDerivatives || isOddlot || isNotOrderTypeLO}
                  label={'Expiry Date'}
                  onChange={onChangeExpiryCheckBox}
                  checked={values.expiryDate != null}
                />
                <div className={styles.MarginTop16}>
                  <DatePicker
                    onChange={onChangeExpiryDate}
                    placeholderText={formatDateToString(
                      dateFns.add(new Date(), { days: 1 }),
                      'dd/MM/yyyy'
                    )}
                    selected={
                      values.expiryDate
                        ? formatStringToDate(values.expiryDate, 'yyyyMMdd')
                        : null
                    }
                    disabled={values.expiryDate == null}
                    position="right"
                    minDate={dateFns.add(new Date(), { days: 1 })}
                    dateFormat={DATE_FORMAT_DISPLAY}
                    filterDate={isWeekday}
                  />
                </div>
              </div>
            </div>

            <ErrorMessage message={errors.expiryDate} />
          </div>
        )}
      </>
    );
  }
}

const mapStateToProps = (state: IState) => ({});

const mapDispatchToProps = {};

const ExpiryDateSection = withErrorBoundary(
  withNamespaces('common')(
    connect(mapStateToProps, mapDispatchToProps)(ExpiryDateComponent)
  ),
  Fallback,
  handleError
);

export default ExpiryDateSection;



// WEBPACK FOOTER //
// ./src/components/common/OrderForm/FormSection/ExpiryDate.tsx